<template>
    <div
        style="
            height: 750px;
            padding: 20px;
            background-color: white;
            overflow-y: auto;
            border-radius: 10px;
            border: black solid 2px;
        "
    >
        <v-card-title style="text-align: center">Search Part</v-card-title>
        <div>
            <v-col cols="6">
                <v-text-field
                    :style="{
                        padding: '0 20px',
                        width: '350px',
                    }"
                    v-model="search"
                    label="Search Part"
                    variant="solo-filled"
                    clearable
                    @update:modelValue="handleSearchUpdate"
                >
                    <template #append-inner>
                        <v-icon
                            :style="{ opacity: '1' }"
                            color="black"
                            icon="mdi:mdi-magnify"
                            theme="light"
                            right
                        />
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="6">
                <v-textarea
                    v-model="description"
                    rows="2"
                    :style="{
                        padding: '0 20px',
                        width: '350px',
                        marginTop: '-25px',
                    }"
                    label="Where Part Description Contains"
                    variant="solo-filled"
                    @update:modelValue="handleDescUpdate"
                >
                </v-textarea>
            </v-col>
        </div>

        <div class="part-row-headers">
            <div class="header row-one row">Part Number</div>
            <div class="header row-three row">Description</div>
            <div class="header row-four row">Type</div>
            <div class="header row-five row">Class</div>
            <div class="header row-two row">Picture</div>
        </div>

        <div
            class="part-row"
            v-for="part in partArray"
            :key="part.PartNum"
            @click="selectPart(part.PartNum)"
        >
            <div class="row-one row data">
                {{ part.PartNum }}
            </div>
            <div class="row-three row data">
                {{ part.PartDescription }}
            </div>
            <div class="row-four row data">
                {{ part.TypeCode }}
            </div>
            <div class="row-five row data">
                {{ part.ClassID }}
            </div>
            <div class="row-two row data">
                <v-img
                    v-if="part.image"
                    :src="part.image"
                    max-width="60"
                    max-height="60"
                    cover
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "PartSearch",
    emits: ["partNumberReceived"],
    props: {},
    data: () => ({
        search: "",
        partArray: [],
        description: "",
    }),
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.fetchPartsData();
    },
    methods: {
        handleSearchUpdate() {
            this.search = this.search.toUpperCase();
            setTimeout(() => {
                this.fetchPartsData();
            }, 50);
        },
        fetchPartsData() {
            try {
                axios
                    .get(
                        route("legacy-api.partsSearch", {
                            search: this.search,
                        })
                    )
                    .then((res) => {
                        this.partArray = res.data;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        handleDescUpdate() {
            this.search = this.search.toUpperCase();
            setTimeout(() => {
                this.fetchPartsDesc();
            }, 50);
        },
        fetchPartsDesc() {
            try {
                axios
                    .get(
                        route("legacy-api.partsSearch", {
                            search: this.search,
                            description: this.description.toUpperCase(),
                        })
                    )
                    .then((res) => {
                        this.partArray = res.data;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        selectPart(partNum) {
            this.$emit("partNumberReceived", partNum);
            this.search = "";
        },
    },
};
</script>

<style scoped>
.part-row {
    display: flex;
    cursor: pointer;
    border-left: 1px gray solid;
    border-bottom: 1px gray solid;
}
.part-row-headers {
    display: flex;
    border-left: 1px gray solid;
    border-bottom: 1px gray solid;
}
.part-row:hover {
    background-color: rgb(211, 211, 211);
}
.header {
    text-align: center;
    font-weight: 600;
    border-bottom: 2px;
}
.row {
    border-bottom: 0;
    border-top: 1px;
    border-right: 1px;
    border-color: gray;
    border-style: solid;
}
.data {
    font-size: 13px;
    padding: 5px;
}
.row-one {
    border-left: 1px;
    width: 20%;
}
.row-two {
    width: 20%;
    border-left: 0;
}
.row-three {
    width: 30%;
    border-left: 0;
}
.row-four {
    width: 15%;
    border-left: 0;
}
.row-five {
    width: 15%;
    border-left: 0;
}
</style>
